import React from "react";
import { supportedColorValues } from "../utils/propTypes";

function Clock({ strokeColor, ...style }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.59375C12.2761 5.59375 12.5 5.81761 12.5 6.09375V12.3409L15.6407 15.59C15.8327 15.7885 15.8273 16.1051 15.6288 16.297C15.4302 16.4889 15.1137 16.4836 14.9218 16.285L11.5 12.7453V6.09375C11.5 5.81761 11.7239 5.59375 12 5.59375Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
        fill={strokeColor}
      />
    </svg>
  );
}

Clock.propTypes = {
  strokeColor: supportedColorValues.isRequired,
};

export default Clock;
